<template>
    <footer>
        <section>
            <header>
                <h2>Mappa del sito:</h2>
            </header>
            <ul>
                <li v-for="page in mainSitePages">
                    <NuxtLink v-bind:to="page.url">
                        {{ page.name }}
                    </NuxtLink>
                </li>
            </ul>
        </section>
        <section>
            <header>
                <h2>Contatti:</h2>
            </header>
            <ul>
                <li>
                    <a class="link contact-maps card card-interactive" href="https://www.google.com/maps/place/Motoclub+citt%C3%A0+di+Riccione/@44.0032393,12.6338059,19z/data=!3m1!4b1!4m13!1m7!3m6!1s0x132cdd59f08220db:0x96ba8c7bd368028a!2sVia+Flaminia,+8,+47838+Riccione+RN!3b1!8m2!3d44.0026699!4d12.6338445!3m4!1s0x132cdd59ef508019:0x787baff70047686c!8m2!3d44.0032377!4d12.6349258">
                        <i class="fa fa-location-dot" />
                        <span>Viale Flaminia, 8 - 47838 Riccione (RN)</span>
                    </a>
                </li>
                <li>
                    <a class="link contact-mail card card-interactive" href="mailto:stefanoavis@gmail.com">
                        <i class="fa fa-envelope" />
                        <span>asdriccioneavis@gmail.com</span>
                    </a>
                </li>
                <li>
                    <a class="link contact-phone card card-interactive" href="tel:+393331111824">
                        <i class="fa fa-phone" />
                        <span>+39 333 111 1824</span>
                    </a>
                </li>
                <li>
                    <a class="link contact-facebook card card-interactive" href="https://www.facebook.com/profile.php?id=100057559715156">
                        <i class="fa fa-brands fa-facebook" />
                        <span>ASD Avis Riccione</span>
                    </a>
                </li>
            </ul>
        </section>
        <section>
            <p>Copyright {{ new Date(Date.now()).getFullYear() }}, Alberto Arduini</p>
        </section>
    </footer>
</template>

<script setup lang="ts">
import { mainSitePages } from '~/client/mainSitePages'
</script>

<style scoped>
footer {
    display: none;
}

@media screen and (width >= 768px) {
    footer {
        background: linear-gradient(to bottom, var(--primary-500), var(--primary-400));
        box-sizing: border-box;
        color: var(--grey-900);
        display: grid;
        grid-template-columns: 1fr 1fr;
        text-align: center;
        padding-top: 1rem;
        clear: both;
    }

    section {
        margin-bottom: 1rem;
    }

    section:nth-child(1) {
        border-right: 1px solid var(--bg-light);
    }

    h2 {
        font-weight: 300;
        margin-bottom: 0.5rem;
    }

    ul {
        list-style-type: none;
    }

    .link {
        --card-background: transparent;

        margin: auto;
        width: fit-content;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        padding: var(--m-small);
        align-items: center;
        gap: var(--m-small);
        text-decoration: none;
    }

    .contact-maps:hover {
        --card-background: hsl(142, 55%, 34%);
    }

    .contact-mail:hover {
        --card-background: var(--accents-500);
    }

    .contact-phone:hover {
        --card-background: var(--secondary-700);
        color: var(--grey-200);
    }

    .contact-facebook:hover {
        --card-background: hsl(217, 87%, 42%);
    }
}
</style>